import React, { useState } from "react";
import ShiftMasterGrid from "./ShiftMasterGrid";
import CardContent from "@/pages/attendanceManagement/components/CardContent";
import DialogForm from "@/components/modal/DialogForm";
import { StyledButton } from "@/components";
import { AddIcon } from "@/icons";
import ShiftForm from "./ShiftForm";
import { useTheme } from "@mui/styles";
import { useGetShiftMasterSampleQuery } from "@/api/services/attendanceMaster/ShiftMaster";
import ReusableButton from "@/components/buttons/StyledButton";
import { DownloadIcon, FileDownloadOutlinedIcon, FileUploadOutlinedIcon } from "@/icons";
import withDialogState from "@/hoc/withDialogState";
import BulkUpload from "./BulkUpload";

const EnhancedShiftForm = withDialogState(ShiftForm);

function ShiftMaster() {
  const [open, setOpen] = useState(false);
  const [openDialog1, setOpenDialog1] = useState(false);
  const theme = useTheme();
  const [selectedRow, setSelectedRow] = useState(null);

  const { data: shiftMasterSample = [], } = useGetShiftMasterSampleQuery();

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen1 = () => {
    setOpenDialog1(!openDialog1);
  }

  const handleSampleDownload = (sampleData, fileName) => {
    if (!sampleData || !(sampleData instanceof Blob)) {
      return;
    }
    const url = URL.createObjectURL(sampleData);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <CardContent
        title="Shift Master"
        actions={[
          <StyledButton
            key="add-policy"
            size="medium"
            icon={<AddIcon />}
            label="Add Shift"
            onClick={() => {
             setSelectedRow(null);
              setOpen(true);
            }}
          />,
          <StyledButton
            size="medium"
            icon={<AddIcon />}
            label="Bulk Upload"
            sx={{
              backgroundColor: theme.palette.BudgieThemeColor.Primary[200],
              color: theme.palette.BudgieThemeColor.Primary[1400],
            }}
            onClick={() => {handleOpen1() }}
          />,
          <ReusableButton
            label="Sample Excel"
            icon={<DownloadIcon />}
            // onClick={handleDownload}
            onClick={() => handleSampleDownload(shiftMasterSample, "sample.xlsx")}
            size="medium"
            variant="outlined"
            type="button"
            sx={{
              // width: "190px", height: "42px",
              borderRadius: "4px",
              color: "hsl(38,92%,50%)",
              background: "rgb(253,239,214)",
              border: "1px solid hsl(38,92%,50%)",
              "&:hover": {
                color: "hsl(38,92%,50%)",
                background: "rgb(253,239,214)",
                border: "1px solid hsl(38,92%,50%)",
              },
            }}
          />,
        ]}
      >
      <EnhancedShiftForm
        open={open}
        setOpen={setOpen}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        onClose={() => {
          setOpen(false)
        }}

      />
      <BulkUpload open={openDialog1} setOpen={setOpenDialog1} />
        <ShiftMasterGrid/>
      </CardContent>
      
    </>
  );
}

export default withDialogState(ShiftMaster);
